import EndPointConfig from '../../models/api/EndPointConfig'

const controller = 'Languages'

export const LanguagesEP : EndPointConfig[] =[
        new EndPointConfig()
        .setMethod("GET")
        .setController(controller)
        .setActionName("GetAvailableLanguages")
]